import Link from '@/components/utilities/SmartLink';
import { slugifyHeading } from '@/utils/glossary-toc';
import { useGlossaryLabels } from '@/utils/glossary-labels';

const ArrowIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    className="text-grey-500 group-hover:text-brand-400 shrink-0 transition-colors"
  >
    <path d="M16.19 2H7.81C4.17 2 2 4.17 2 7.81V16.18C2 19.83 4.17 22 7.81 22H16.18C19.82 22 21.99 19.83 21.99 16.19V7.81C22 4.17 19.83 2 16.19 2ZM17.25 12.33C17.25 12.74 16.91 13.08 16.5 13.08C16.09 13.08 15.75 12.74 15.75 12.33V9.31L8.03 17.03C7.88 17.18 7.69 17.25 7.5 17.25C7.31 17.25 7.12 17.18 6.97 17.03C6.68 16.74 6.68 16.26 6.97 15.97L14.69 8.25H11.67C11.26 8.25 10.92 7.91 10.92 7.5C10.92 7.09 11.26 6.75 11.67 6.75H16.5C16.91 6.75 17.25 7.09 17.25 7.5V12.33Z" />
  </svg>
);

const GlossaryFurtherReading = ({ title, items = [] }) => {
  const labels = useGlossaryLabels();
  const resolvedTitle = title || labels.furtherReadingTitle;

  if (items.length === 0) return null;

  const headingId = resolvedTitle ? slugifyHeading(resolvedTitle) : undefined;

  return (
    <section className="bg-grey-50 mt-13 rounded-2xl p-7">
      {resolvedTitle && (
        <h2 id={headingId} className="text-grey-950 mb-5 text-[32px] leading-tight font-light">
          {resolvedTitle}
        </h2>
      )}
      <ul className="flex flex-col">
        {items.map((item) => (
          <li key={item.id} className="border-grey-200 border-b last:border-b-0">
            <Link
              href={item.url}
              target="_blank"
              rel="noopener"
              className="group text-grey-800 hover:text-brand-400 flex items-center gap-3 py-3.5 text-[15px] font-medium transition-colors"
            >
              <ArrowIcon />
              <span>{item.label}</span>
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default GlossaryFurtherReading;
